import Helpers from './../library/Helpers';

export default class Content {

	constructor() {
		this.instance = self;
	}

	static init() {
		const self = new Content;
		self.attachEvents();
	}

	attachEvents() {
		const self = this;

		$('.js-read-more-content').each(function() {
			self.applyReadMoreContent($(this));
		});

		$(window).on('resize', Helpers.debounce(function () {
			$('.js-read-more-content').each(function() {
				self.applyReadMoreContent($(this));
			});
		}, 200));

		$(document).on('click', '.js-toggle-read-more-content', function(e) {
			e.preventDefault();
			self.toggleReadMoreContent($(this).parents('.js-read-more-content'));
		});

		$('.js-large-nav-popup a').addClass('js-popup-inline');

		$('.js-smooth-scroll').on('click', function(e){
		    e.preventDefault();

		    $('html, body').animate({
		        scrollTop: $($.attr(this, 'href')).offset().top
		    }, 500);
		});

		$('.js-ga-event').on('click', function(){
			self.gaEventFire($(this));
		});
	}

	applyReadMoreContent($content) {
		const self = this;

		$content.removeClass('is-active');

		if ($content.height() > 100) {
			$content.addClass('is-active');
		} else {
			$content.removeClass('is-active');
		}
	}

	toggleReadMoreContent($content) {
		const self = this,
			$link = $content.find('.js-toggle-read-more-content');

		if ($content.hasClass('is-expanded')) {
			$content.css({'height': '124px'});
			$link.text('Read More');

			$content.removeClass('is-expanded');
		} else {
			$content.css({'height': 'auto'});
			$link.text('Show Less');

			$content.addClass('is-expanded');
		}
	}

	gaEventFire(element) {
		const self = this;

		// GA event tracking on links
		var $this = element,
			eventAction = ($this.data('ga-action') ? $this.data('ga-action') : 'submit');

		if (typeof gtag === 'function') {
			gtag('event', eventAction, {
				'event_category': $this.data('ga-category'),
				'event_label': $this.data('ga-label'),
			});
		} else if (typeof ga === 'function') {
			ga('send', {
				hitType: 'event',
				eventCategory: $this.data('ga-category'),
				eventAction: eventAction,
				eventLabel: $this.data('ga-label')
			});
		}
	}
}
